import { buildQueryParams, getResData, httpClient } from "utils";

import { ApprovalsRequestBody, ApprovalsResponse, ApprovalsResponseById, UndoApprovalV2Body } from "./types";

export const APPROVALS_BASE_PATH = "/approvals/v2";

export const APPROVALS_API_PATHS = {
  DOCUMENT_APPROVAL_BY_ID: (approvalId: any) => `${APPROVALS_BASE_PATH}/${approvalId}`,
  DOCUMENT_APPROVAL: APPROVALS_BASE_PATH,
  APPROVAL_BILL_SIGNOFF_DATA: `${APPROVALS_BASE_PATH}/signoff/bills`,
  APPROVAL_BILL_LOCK_DATA: `${APPROVALS_BASE_PATH}/lock/bills`,
  CREATE_APPROVAL_SIGNOFF: `${APPROVALS_BASE_PATH}/signoff`,
  CREATE_APPROVAL_LOCK: `${APPROVALS_BASE_PATH}/lock`,
  UNDO_APPROVAL_SIGNOFF: `${APPROVALS_BASE_PATH}/undo-signoff`,
  UNDO_APPROVAL_LOCK: `${APPROVALS_BASE_PATH}/undo-lock`,
};

export const createApprovalBillData = (body: ApprovalsRequestBody) =>
  httpClient.post(APPROVALS_API_PATHS.APPROVAL_BILL_SIGNOFF_DATA, body);

export const createLockedBillData = (body: ApprovalsRequestBody) =>
  httpClient.post(APPROVALS_API_PATHS.APPROVAL_BILL_LOCK_DATA, body);

export const createApprovalSignOff = (payload: ApprovalsRequestBody) =>
  httpClient.post(APPROVALS_API_PATHS.CREATE_APPROVAL_SIGNOFF, payload);

export const createApprovalLock = (payload: any) =>
  httpClient.post(APPROVALS_API_PATHS.CREATE_APPROVAL_LOCK, payload);

export const getApprovalsData = (query: any) =>
  httpClient.get<ApprovalsResponse>(`${APPROVALS_API_PATHS.DOCUMENT_APPROVAL}?${buildQueryParams(query)}`).then(getResData);

export const getApprovalsDataById = (query: { id: number | string, siteName: string, monthYear: string }) =>
  httpClient.get<ApprovalsResponseById>(`${APPROVALS_API_PATHS.DOCUMENT_APPROVAL}/${query.id}?siteName=${query.siteName}&monthYear=${query.monthYear}`).then(getResData);

export const undoApprovalSignOff = (body: UndoApprovalV2Body) =>
  httpClient.delete(`${APPROVALS_API_PATHS.UNDO_APPROVAL_SIGNOFF}`, { data: body });

export const undoApprovalLock = (body: UndoApprovalV2Body) =>
  httpClient.delete(`${APPROVALS_API_PATHS.UNDO_APPROVAL_LOCK}`, { data: body });
